import React from 'react';

import ButtonCollection from './ButtonCollection';
import { DeleteButton } from './ConfirmButton';
import UrlField from './UrlField';

const VideoUploader = (props) => {
	return (
		<div>
			<div class="gui_video_uploader">
				<UrlField
					_class={props?._class ?? {}}
					name={props.name}
					value={props?.value ?? ((props.model != undefined) ? props.model[props.name] : '')}
					change={props.change}
					placeholder="Insert the URL of the video"
					label_props={{
						addition:"YouTube or Vimeo",
					}}
				>{props.children}</UrlField>

				<ButtonCollection _class={{other:'floating_actions'}}>
					<DeleteButton
						squared={true}
						onClick={(e) => props.change(props.name, '')}
					/>
				</ButtonCollection>
			</div>
		</div>
	)
}

export default VideoUploader;